import { render } from "./AnnotateLabelGroups.vue?vue&type=template&id=6d95a224"
import script from "./AnnotateLabelGroups.vue?vue&type=script&lang=js"
export * from "./AnnotateLabelGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__